<template>
  <div v-if="visible" class="jjlb-overlay" @click.self="onCancel">
    <div class="jjlb-dialog">
      <div class="jjlb-title">
        <span>{{ title }}</span>
        <span class="jjlb-close" @click="onCancel">×</span>
      </div>
      <div class="jjlb-body">
        <div class="jjlb-row">
          <label class="jjlb-label">紧急类别：</label>
          <div class="jjlb-options">
            <el-checkbox-group v-model="selected">
              <el-checkbox v-for="item in options" :key="item.value" :value="Number(item.value)">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
            <div v-if="options.length < 1" class="jjlb-empty">未获取到紧急类别配置。</div>
          </div>
        </div>
        <div class="jjlb-tip">勾选任意类别即设为紧急图斑；全部不勾选则取消紧急图斑（<code>Flag</code> 置空、<code>JJLB</code> 置 0）。</div>
      </div>
      <div class="jjlb-footer">
        <button type="button" class="jjlb-btn" @click="onCancel">取消</button>
        <button type="button" class="jjlb-btn jjlb-btn-primary" @click="onConfirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JjlbSetDialog',
  props: {
    visible: { //是否显示
      type: Boolean,
      default: false,
    },
    value: { //当前JJLB位掩码值
      type: Number,
      default: 0,
    },
    config: { //紧急类别配置（tableConfig/wthz.json 的 wthz_jjlb）
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selected: [], //已勾选的位值
    };
  },
  computed: {
    title() {
      return (this.config && this.config.title) || '紧急图斑设定';
    },
    options() { //候选项全部来自配置，新增子类无需改代码
      return (this.config && this.config.items) ? this.config.items : [];
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() { //用当前值初始化勾选状态
      const n = Number(this.value) || 0;
      this.selected = this.options
        .filter(item => (n & Number(item.value)) === Number(item.value))
        .map(item => Number(item.value));
    },
    onCancel() {
      this.$emit('close');
    },
    onConfirm() {
      const jjlb = this.selected.reduce((acc, val) => acc | Number(val), 0);
      this.$emit('confirm', { JJLB: jjlb });
    },
  },
};
</script>

<style scoped>
.jjlb-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jjlb-dialog {
  width: 340px;
  background-color: #f0f0f0;
  border: 1px solid #999;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  text-align: left;
}

.jjlb-title {
  background-color: #e0e0e0;
  padding: 6px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}

.jjlb-close {
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.jjlb-body {
  padding: 12px 10px;
}

.jjlb-row {
  display: flex;
  align-items: flex-start;
}

.jjlb-label {
  width: 80px;
  line-height: 24px;
  flex-shrink: 0;
}

.jjlb-options {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.jjlb-empty {
  color: #999;
  line-height: 24px;
}

.jjlb-tip {
  margin-top: 8px;
  color: #999;
  font-size: 12px;
  line-height: 18px;
}

.jjlb-footer {
  padding: 8px 10px;
  text-align: right;
  border-top: 1px solid #d0d0d0;
}

.jjlb-btn {
  margin-left: 8px;
  padding: 2px 14px;
  cursor: pointer;
}

.jjlb-btn-primary {
  background-color: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
</style>
